import { message } from 'antd'

export const useValidatePrompt = () => {
  const validatePrompt = (prompt: string) => {
    console.log(prompt, 'prompt')

    if (/(https|http)\:\/\/[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,}/.test(prompt)) {
      message.destroy()
      message.error('画面描述无法携带url链接，请删除')
      return false
    }
    return true
  }
  return {
    validatePrompt,
  }
}
